import React, { type CSSProperties } from 'react';

import Table from '@mui/material/Table';

import DraggableRow from 'components/tables/dndStandardTable/tableComponents/DraggableRow';
import TableHeadCell from 'components/tables/dndStandardTable/tableComponents/TableHeadCell';
import { type ColumnData, type RowConfigInterface, type RowData } from 'components/tables/dndStandardTable/types';

interface TableRowPreviewProps<T extends RowData> {
  columns: ColumnData<T>[];
  itemWrapper: any;
  rowConfig?: RowConfigInterface;
  style?: CSSProperties;
}

const TableRowPreview = <T extends RowData>({ columns, itemWrapper, rowConfig, style }: TableRowPreviewProps<T>) => {
  const item = itemWrapper.item;

  return rowConfig?.draggableRow ? (
    <Table style={{ boxShadow: '0 0 3px 1px #c8c8c8', ...style }}>
      <thead>
        <tr style={{ visibility: 'collapse' }}>
          {columns.map((column) => (
            <TableHeadCell key={column.key} column={column} />
          ))}
        </tr>
      </thead>
      <tbody>
        <DraggableRow
          columns={columns}
          customClassName={item.className}
          index={itemWrapper.startIndex}
          rowItem={item}
        />
      </tbody>
    </Table>
  ) : null;
};

export default TableRowPreview;
